import React from "react";
import { Image } from "semantic-ui-react";

const TeamMemberItem = ({ picture, name, position, description }) => {
    return (
        <div className="bootstrap-styles">
            <div className="olympus-styles">
                <div className="crumina-module crumina-teammembers-item">
                    <div>
                        <Image
                            size="small"
                            className="circular centered"
                            src={picture}
                            alt="team member"
                        />
                    </div>
                    <div className="teammember-content">
                        <h5 className="teammembers-item-name">{name}</h5>
                        <div style={{ fontSize: "14px" }}>{position}</div>
                        <div className="teammembers-item-prof">
                            {" "}
                            {description}{" "}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TeamMemberItem;
